// A `fill` wizard's way back into the screen that opened it
// (docs/plans/wizard-external-website-step.md §7).
//
// <TxnScreen> provides it around the open record: `seed()` is the buffer the
// wizard starts from (the header values and the rows of every top-level child
// form, saved or not), `apply()` merges what the wizard hands back — header
// values set, rows appended — into that buffer, marked unsaved. Nothing is
// written: the user's own save does that, under the transaction's rules.
// The action button (FormRenderer, any form) reads it; absent → no fill.

import { createContext, useContext } from 'react'
import type { WizardFillResult } from '../../wizard/contract'

export interface WizardFillTarget {
  seed(): { header: Record<string, unknown>; details: Record<string, Array<Record<string, unknown>>> }
  apply(result: WizardFillResult): void
}

export const WizardFillContext = createContext<WizardFillTarget | null>(null)

export function useWizardFill(): WizardFillTarget | null {
  return useContext(WizardFillContext)
}
